import { AuthenticationGuard } from '@trimble/trimble-id-solidjs';
import { JSX } from 'solid-js';
import {
  ApiServiceProvider,
  ApiServiceProviderProps,
} from './ApiServiceProvider';
import { AppContextProvider } from './AppContextProvider';
import { DataContextProvider } from './data-state/DataContextProvider';
import { CapabilityRegistryProvider } from './CapabilityRegistryProvider';
import { ThemeContextProvider } from './ThemeContextProvider';
import { ProjectSettingsProvider } from './ProjectSettingsProvider';
import { LocaleProvider } from './LocaleProvider';
import { TranslationProviderWithUserLanguage } from './TranslationProviderWithUserLanguage';
import { ConnectProjectProvider } from '@trimble/connect-project-providers';

export interface ProtectedLayoutProviderProps extends ApiServiceProviderProps {
  envName: string;
  deployedTag?: string;
  connectUrl: string;
}

export function ProtectedLayoutProvider(
  props: ProtectedLayoutProviderProps
): JSX.Element {
  return (
    <AuthenticationGuard>
      <ApiServiceProvider
        alignmentsDomain={props.alignmentsDomain}
        mobileMappingDomain={props.mobileMappingDomain}
        seuratDomain={props.seuratDomain}
        imagingDomain={props.imagingDomain}
        tcTcpsDomain={props.tcTcpsDomain}
        tcUserDomain={props.tcUserDomain}
        ecomDomain={props.ecomDomain}
        coordinatesDomain={props.coordinatesDomain}
        clientName={props.clientName}
        clientVersion={props.clientVersion}
        isProductionEnvironment={props.isProductionEnvironment}
      >
        <ConnectProjectProvider connectUrl={props.connectUrl}>
          <LocaleProvider>
            <TranslationProviderWithUserLanguage>
              <ThemeContextProvider>
                <AppContextProvider
                  envName={props.envName}
                  deployedTag={props.deployedTag}
                >
                  <ProjectSettingsProvider>
                    <DataContextProvider>
                      <CapabilityRegistryProvider>
                        {props.children}
                      </CapabilityRegistryProvider>
                    </DataContextProvider>
                  </ProjectSettingsProvider>
                </AppContextProvider>
              </ThemeContextProvider>
            </TranslationProviderWithUserLanguage>
          </LocaleProvider>
        </ConnectProjectProvider>
      </ApiServiceProvider>
    </AuthenticationGuard>
  );
}
